import maAccordion from '@/components/accordion'
import maNavbarStepper from '@/components/navbarStepper'
import maModal from '@/components/modal'
import { FLOW_TRANSITIONS } from '@/modules/Flow/constants'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import { WARRANTY_MODULE_NAME } from '@/store/types'
import { FLOW_MODULE_NAME } from '@/modules/Flow/store/types'
import { mapState } from 'vuex'

export default {
  name: 'claimSummary',
  mixins: [flowMixin],
  components: {
    maAccordion,
    maNavbarStepper,
    maModal
  },
  data() {
    return {
      damagesList: [],
      damages: {},
      fraisDamages: {},
      fraisDamagesObj: {},
      damagesImmobilier: [],
      address: null,
      renInfo: {},
      summary: {},
      mobilierDamages: []
    }
  },
  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyResultDeclaration: 'resultDeclaration',
      stateWarrantyWarranties: 'warranties',
      stateWarrantyAddress: 'address',
      stateWarrantySinisterSummary: 'sinisterSummary'
    }),
    ...mapState(FLOW_MODULE_NAME, {
      stateFlowState: 'flowState',
      stateFlowViewOptions: 'flowViewOptions'
    }),

    ...mapState(['date']),

    isInmobilier() {
      if (this.stateFlowViewOptions.smart_values.inmobilier !== null) {
        return true
      }
    },
    isMobilier() {
      if (this.stateFlowViewOptions.smart_values.mobilier) {
        return true
      }
    },
    isFrais() {
      return (
        this.stateFlowViewOptions.smart_values.frais.compensation_base !== 0
      )
    },
    isFranchise() {
      if (this.damages.inmobilier.franchise !== 0) {
        return this.damages.inmobilier.franchise
      }
    },
    isRen() {
      return this.stateFlowState === 'REN_RESUME'
    },

    isBillma() {
      return this.stateFlowState === 'BILLMA_RESUME'
    },
    isGag() {
      return this.stateFlowState === 'GAG_RESUME'
    },
    isDataRen() {
      return this.stateFlowViewOptions.data_ren
    },
    isSummary() {
      return this.stateWarrantySinisterSummary
    },
    isOnlyImmobilier() {
      if (this.isInmobilier && !this.isFrais && !this.isMobilier) {
        return true
      }
    },
    isRenCalendarFailure() {
      return (
        this.stateFlowViewOptions &&
        this.stateFlowViewOptions.hasOwnProperty('resumeBillmaOrRenFailure') &&
        this.stateFlowViewOptions.resumeBillmaOrRenFailure.isRenCalendarFailure
      )
    },
    isBillMaDocumentFailure() {
      return (
        this.stateFlowViewOptions &&
        this.stateFlowViewOptions.hasOwnProperty('resumeBillmaOrRenFailure') &&
        this.stateFlowViewOptions.resumeBillmaOrRenFailure.isBillMaDocumentFailure
      )
    },
    isRenOrBillmaDocFailure() {
      return this.isBillMaDocumentFailure || this.isRenCalendarFailure
    },
    franchiseBlueContainerText() {
      if (this.stateFlowViewOptions.hasOwnProperty('resumeFranchiseLiterals')) {
        return this.stateFlowViewOptions
          .resumeFranchiseLiterals
          .franchiseBlueContainerText
      }
      return null
    },
    franchiseBelowContainerText() {
      if (this.stateFlowViewOptions.hasOwnProperty('resumeFranchiseLiterals')) {
        return this.stateFlowViewOptions
          .resumeFranchiseLiterals
          .franchiseBelowContainerText
      }
      return null
    },
    franchiseValue() {
      if (this.damages.inmobilier.franchise !== 0) {
        return this.damages.inmobilier.franchise
      } else {
        return 0
      }
    }
  },
  methods: {
    setDamagesData() {
      this.damages = JSON.parse(
        JSON.stringify(this.stateFlowViewOptions.smart_values)
      )
    },

    setRenInfo() {
      if (this.isDataRen) {
        this.renInfo = JSON.parse(
          JSON.stringify(this.stateFlowViewOptions.data_ren)
        )
      }
    },

    setSummaryInfo() {
      this.summary = this.stateWarrantySinisterSummary
    },
    handleOpenDescriptionModal() {
      this.$refs.modalDescription.showModal = true
    },
    handleCloseDescriptionModal() {
      this.$refs.modalDescription.showModal = false
    },

    handlePrimaryButtonClick() {
      if (this.isRenOrBillmaDocFailure) {
        this.goToNextState(FLOW_TRANSITIONS.FINISHED_KO)
      }else{
        this.goToNextState(FLOW_TRANSITIONS.FINISHED_OK)
      }
      
    },
    handleFraisData() {
      this.fraisDamagesObj = this.damages.frais

      let { compensation_base, ...fraisDamages } = this.fraisDamagesObj

      this.fraisDamages = Object.values(fraisDamages)
    },
    handleOpenRenDescriptionModal() {
      this.$refs.modalRenDescription.showModal = true
    },
    handleCloseRenDescriptionModal() {
      this.$refs.modalRenDescription.showModal = false
    },

    mapMobilierDamages() {
      // TODO: update mapper when specific mobilier damages is created
      if (Object.keys(this.stateWarrantyWarranties).length > 0) {
        const mobilierDamagesArray = this.stateWarrantyWarranties.mobilier.damages

        this.mobilierDamages = mobilierDamagesArray.map((damageData) => {
          const { damage } = damageData

          return {
            name:
              (damage &&
                damage.description &&
                damage.description.split(',')[0]) ||
              '-',
            date: (damage && damage.purchase_date) || '-',
            reference:
              (damage &&
                damage.original_product &&
                damage.original_product.model) ||
              '-',
            amount:
              (damageData &&
                damageData.artessian_repair &&
                damageData.artessian_repair.market_price_with_taxes) ||
              0,
            category: damage && damage.category.split(',')[1],
            brand:
              damage && damage.original_product && damage.original_product.brand,
            product: damage && damage.product.split(',')[0]
          }
        })
      }
      // this.mobilierDamages.push(damage)
    },
    replaceDots(value) {
      if (value) {
        if (typeof value === 'number') {
          value = value.toString()
        }
        let valueComma = value.replace(/\./g, ',')

        return valueComma
      }
    }
  },

  mounted() {
    this.setRenInfo()
    this.setSummaryInfo()
    this.setDamagesData()
    this.handleFraisData()
    this.mapMobilierDamages()
    this.address = this.stateWarrantyAddress
    localStorage.setItem('e2eFlow', this.stateFlowState)
  }
}
